import { render, staticRenderFns } from "./CenterViewEventList_Ap.vue?vue&type=template&id=31559418&scoped=true"
import script from "./CenterViewEventList_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewEventList_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewEventList_Ap.vue?vue&type=style&index=0&id=31559418&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31559418",
  null
  
)

export default component.exports